/** Paths for the marketing section. The admin mounts every one of these under /marketing. */
const MARKETING_BASE = '/marketing';

export const MARKETING_ROUTES = {
  influencers: MARKETING_BASE,
  brandManager: `${MARKETING_BASE}/brand-manager`,
  templateManager: `${MARKETING_BASE}/template-manager`,
  campaignMatcher: `${MARKETING_BASE}/campaign-matcher`,
  community: `${MARKETING_BASE}/community`,
  affiliate: `${MARKETING_BASE}/affiliate`,
  campaignDetail: (campaignId: string) => `${MARKETING_BASE}/influencer-campaigns/${encodeURIComponent(campaignId)}`,
} as const;
